import React from "react";
import styles from "./styles.css";
import Evaluating from "./images/evaluating.png";
import PostInspectionDiyPreviousOffer from "../post-inspection-diy-previous-offer";

const PostInspectionDiyAuctionNotStarted = () => {

    return (
        <React.Fragment>
            <h3 styleName={"styles.auctionNotStartedHeader"}>We're reviewing your car details, and<br/>the auction will start soon</h3>
            <div styleName={"styles.evaluatingInspection"}>
                <img src={Evaluating} alt="Evaluating"/>
                <div styleName={"styles.auctionStart"}>
                    <h4>Usually takes 10-15 minutes! </h4>
                </div>
            </div>
            <PostInspectionDiyPreviousOffer
                showMsg={true}
                expiredOfferStyle={"expiredOffer"}
                isExpiredOffer={true}
            />
        </React.Fragment>
    );
};

export default PostInspectionDiyAuctionNotStarted;

